<div
  class="card card-custom"
  [ngClass]="{
    'card-body-progress': viewLoading,
    'card-body-progress-overlay': loadingAfterSubmit
  }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <div class="card-body">
    <div class="mat-table-wrapper">
      <form>
        <mat-table
          class="lmat-elevation-z8"
          [dataSource]="dataSource"
          #sort="matSort"
          matSort
          multiTemplateDataRows
          matSortActive="id"
          matSortDirection="asc"
          matSortDisableClear
        >
          <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column"
              >ID
            </mat-header-cell>
            <mat-cell *matCellDef="let agreement" class="mat-column gl-block">
              <span>{{ agreement.id }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column"
              >Status
            </mat-header-cell>
            <mat-cell *matCellDef="let agreement" class="mat-column gl-block">
              <span>{{ agreement.status }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="date_sent">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column"
              >Date Sent
            </mat-header-cell>
            <mat-cell *matCellDef="let agreement" class="mat-column gl-block">
              <span>{{ agreement.date_sent | date : 'MM-dd-yy, h:mm a' }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="date_signed">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column"
              >Date Signed
            </mat-header-cell>
            <mat-cell *matCellDef="let agreement" class="mat-column gl-block">
              <span>{{ agreement.date_signed | date : 'MM-dd-yy, h:mm a' }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="start_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column"
              >Start Date
            </mat-header-cell>
            <mat-cell *matCellDef="let agreement" class="mat-column gl-block">
              <span>{{ agreement.start_date | date : 'MM-dd-yy, h:mm a' }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="end_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column"
              >End Date
            </mat-header-cell>
            <mat-cell *matCellDef="let agreement" class="mat-column gl-block">
              <span>{{ agreement.end_date | date : 'MM-dd-yy, h:mm a' }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="void_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column"
              >Revoke Date
            </mat-header-cell>
            <mat-cell *matCellDef="let agreement" class="mat-column gl-block">
              <span>{{ agreement.void_date | date : 'MM-dd-yy, h:mm a' }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="void_reason">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column"
              >Revoke Reason
            </mat-header-cell>
            <mat-cell *matCellDef="let agreement" class="mat-column gl-block">
              <span>{{ agreement.void_reason }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef class="mat-column" translate="TABLE.ACTIONS"
              >Actions
            </mat-header-cell>
            <mat-cell *matCellDef="let agreement" class="mat-column gl-block">
              <ng-template ngxPermissionsOnly="canViewAgreement">
                <button
                  matTooltip="View Agreement"
                  class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                  (click)="viewAgreementButtonOnClick(agreement)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/visible.svg"
                    class="svg-icon svg-icon-md svg-icon-success"
                  ></span>
                </button>
              </ng-template>
              <ng-template ngxPermissionsOnly="canRemindAgreement">
                <button
                  [disabled]="
                    ['COMPLETED', 'REVOKED', 'REMINDED'].includes(agreement.status.toUpperCase())
                  "
                  matTooltip="Remind Agreement"
                  class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                  (click)="remindAgreementButtonOnClick(agreement)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/marketing.svg"
                    class="svg-icon svg-icon-md svg-icon-primary"
                  ></span>
                </button>
              </ng-template>

              <ng-template ngxPermissionsOnly="canRevokeAgreement">
                <button
                  [disabled]="['REVOKED'].includes(agreement.status.toUpperCase())"
                  matTooltip="Revoke Agreement"
                  class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                  (click)="revokeAgreementButtonOnClick(agreement)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                    class="svg-icon svg-icon-md svg-icon-danger"
                  ></span>
                </button>
              </ng-template>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </form>
      <div
        class="mat-table__message"
        *ngIf="
          contactRelationshipsResult.length == 0 &&
          !loading &&
          !(dataSource.isPreloadTextViewed$ | async)
        "
      >
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <!-- Message for empty data  -->
      <div class="mat-table__message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table__bottom" hidden>
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
    <!-- end: BOTTOM -->
  </div>
  <div class="card-footer">
    <mat-spinner [diameter]="20" *ngIf="actionLoading"></mat-spinner>
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button
          type="button"
          mat-raised-button
          cdkFocusInitial
          (click)="onNoClick()"
          matTooltip="Close"
        >
          <span translate="GLOBAL.CLOSE">Close</span></button
        >&nbsp;
      </div>
    </div>
  </div>
</div>
